import './LandCustomTitleBar.css'
import 'antd/dist/reset.css'
import React from 'react'
import { ConfigProvider, Menu, Space, Popover, FloatButton, Button } from 'antd'
import { PhoneOutlined, MailOutlined, SearchOutlined } from '@ant-design/icons'
import Logo from '../../images/company/logo3.jpg'
import DownArrow from '../../images/widget/down_arrow.svg'

const itemAttrs = [
  {
    label: '首页',
    key: 'home',
  },
  {
    label: '产品',
    key: 'product',
  },
  {
    label: '行业',
    key: 'industry',
  },
  {
    label: '公司',
    key: 'company',
  },
  {
    label: 'Keystride创新',
    key: 'innovation',
  },
]

export default class LandCustomTitleBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedKeys: [],
    }
  }

  componentDidMount() {}

  render() {
    return (
      <div ref={this.props.titleBarRef} className="LandCustomTitleBar">
        <img
          src={Logo}
          className="LandCompanyLogo"
          onClick={() => this.backToMainPage()}
        />

        <ConfigProvider
          theme={{
            components: {
              Menu: {
                itemPaddingInline: 15,
              },
            },
          }}
        >
          <Menu
            className="LandMenu"
            items={this.getMenuItems(itemAttrs)}
            mode="horizontal"
            style={{
              flex: 'auto',
              minWidth: 0,
              marginLeft: '3vw',
            }}
            // selectedKeys={this.props.getCurrentSelectedTitlebarSelectedItemKeys()}
            selectable={false}
            onClick={(item, key, keyPath, domEvent) => {
              if (item.key == 'home') {
                this.backToMainPage()
              }
            }}
          />
        </ConfigProvider>

        <Popover
          title={this.getContactTitle()}
          content={this.getContactContent()}
        >
          <Button
            shape="circle"
            style={{ marginRight: 20 }}
            icon={<PhoneOutlined style={{ color: 'black', fontSize: 18 }} />}
            onClick={this.viewContact}
          />
        </Popover>

        <div
          className="LandCustomTitleBarSearchWrapper"
          onClick={this.viewProductList}
        >
          <div className="LandCustomTitleBarSearchText">检索公司产品</div>
          <SearchOutlined style={{ fontSize: 16, color: 'white' }} />
        </div>
      </div>
    )
  }

  getMenuItems = (itemAttrs) => {
    let items = []
    for (var i = 0; i < itemAttrs.length; i++) {
      let attr = itemAttrs[i]
      items.push({
        label: this.getMenuItemFromAttr(attr),
        key: attr.key,
      })
    }
    return items
  }

  getMenuItemFromAttr = (attr) => {
    return (
      <div ref={this.getMenuItemRef(attr.key)}>
        <Space>
          <div className="LandMenuItem">{attr.label}</div>
          {attr.key == 'home' ? null : (
            <img
              className={this.getMenuIconStatus(attr.key)}
              src={DownArrow}
              style={{ width: 14, height: 14 }}
            />
          )}
        </Space>
      </div>
    )
  }

  getMenuItemRef = (key) => {
    if (key === 'home') {
      return this.props.homeProps.menuRef
    }
    if (key === 'product') {
      return this.props.productProps.menuRef
    }
    if (key === 'industry') {
      return this.props.industryProps.menuRef
    }
    if (key === 'company') {
      return this.props.companyProps.menuRef
    }
    if (key === 'innovation') {
      return this.props.innovationProps.menuRef
    }
    return null
  }

  getMenuIconStatus = (key) => {
    if (key === 'product') {
      return this.getMenuIconStatusFromProps(this.props.productProps)
    }
    if (key === 'industry') {
      return this.getMenuIconStatusFromProps(this.props.industryProps)
    }
    if (key === 'company') {
      return this.getMenuIconStatusFromProps(this.props.companyProps)
    }
    if (key === 'innovation') {
      return this.getMenuIconStatusFromProps(this.props.innovationProps)
    }
  }

  getMenuIconStatusFromProps = (props) => {
    if (!props.menuIconRotated) {
      return ''
    }
    if (props.menuIconRotateUp || props.drawerOpening) {
      return 'LandMenuIconRotateUp'
    }
    if (props.menuIconRotateDown || !props.drawerOpening) {
      return 'LandMenuIconRotateDown'
    }
  }

  updateSelectedKeys = (key) => {
    var keys = []
    keys.push(key)
    this.setState({ selectedKeys: keys })
  }

  getContactTitle = () => {
    return <div className="LandCustomTitleBarContactTitle">联系我们</div>
  }

  getContactContent = () => {
    return (
      <div className="LandCustomTitleBarContactWrapper">
        <div className="LandCustomTitleBarContactPosition">商务</div>
        <div className="LandCustomTitleBarContactContent">
          <Space>
            <PhoneOutlined style={{ fontSize: 14 }} />
            <div className="LandCustomTitleBarContactMethod">电话</div>
          </Space>
          <div className="LandCustomTitleBarContactName">{'17625997856'}</div>
        </div>
        <div className="LandCustomTitleBarContactContent">
          <Space>
            <MailOutlined style={{ fontSize: 14 }} />
            <div className="LandCustomTitleBarContactMethod">邮箱</div>
          </Space>
          <div className="LandCustomTitleBarContactName">
            {'sales@keystridevalve.com'}
          </div>
        </div>

        <div className="LandCustomTitleBarContactPosition">技术</div>
        <div className="LandCustomTitleBarContactContent">
          <Space>
            <PhoneOutlined style={{ fontSize: 14 }} />
            <div className="LandCustomTitleBarContactMethod">电话</div>
          </Space>
          <div className="LandCustomTitleBarContactName">{'13905285116'}</div>
        </div>
        <div className="LandCustomTitleBarContactContent">
          <Space>
            <MailOutlined style={{ fontSize: 14 }} />
            <div className="LandCustomTitleBarContactMethod">邮箱</div>
          </Space>
          <div className="LandCustomTitleBarContactName">
            {'supportmaster@keystridevalve.com'}
          </div>
        </div>
      </div>
    )
  }

  getClientWHRatio = () => {
    return (
      (document.documentElement.clientWidth * 1.0) /
      document.documentElement.clientHeight
    )
  }

  backToMainPage = () => {
    this.props.history.push('/')
  }

  viewProductList = () => {
    this.props.history.push('/product_list')
  }

  viewContact = () => {
    this.props.history.push('/contact')
  }

  gotoShop = () => {
    window.open('https://mall.jd.com/index-12045041.html', '_blank')
  }
}
